module.exports = __webpack_public_path__ + "img/HU14413591.7f88c7df.png";